module.exports = ".page-footer{\r\n    background-color: #3b778a45;\r\n}"